The details of the process history items uploaded alongside the candidate.

The upload operation is atomic;
if you receive an `UploadCandidatePayload_Success` payload,
all process history items were successfully uploaded.
Input order is preserved to allow your software to record the `id` assigned to each item.
